export enum Tenant {
    LT = 'LT',
    LV = 'LV',
    EE = 'EE',
}
